{
  "form": {
    "input_placeholder": "Tambah tugasan…",
    "parseWithAi_aria": "Huraikan tugasan dengan AI",
    "parseWithAi_title": "Kemas kini dan tetapkan keutamaan dengan AI",
    "priorityLabel_aria": "Keutamaan tugasan",
    "add": "Tambah",
    "signInForAi": "Log masuk untuk menggunakan ciri AI.",
    "aiUnavailable": "AI tidak tersedia. Cuba lagi.",
    "saveTo": "Simpan ke",
    "saveTo_aria": "Simpan ke {{list}}",
    "saveToSynced_aria": "Simpan ke {{list}}, {{provider}}",
    "addedTo": "Ditambah ke {{list}}",
    "addedToSynced": "Ditambah ke {{list}} · {{provider}}",
    "show": "Tunjukkan"
  },
  "priority": {
    "Critical": "Kritikal",
    "High": "Tinggi",
    "Medium": "Sederhana",
    "Low": "Rendah"
  },
  "item": {
    "edit_aria": "Edit tugasan",
    "delete_aria": "Padam tugasan",
    "addStep": "Tambah langkah",
    "addStep_placeholder": "Tambah langkah…",
    "addStep_aria": "Tambah langkah pada {{task}}",
    "steps_group_aria": "Langkah-langkah {{task}}",
    "steps_progress_aria": "{{done}} daripada {{count}} langkah selesai",
    "completeSteps_aria": "{{task}}. Turut melengkapkan {{count}} langkah yang belum selesai"
  },
  "list": {
    "title": "Tugasan",
    "newListFallback": "Senarai Baharu",
    "completedMeta": "{{completed}} daripada {{total}} selesai",
    "deleteConfirm": "Padam \"{{name}}\"?",
    "rename_title": "Namakan semula",
    "deleteList_title": "Padam senarai",
    "newListName_placeholder": "Nama senarai…",
    "newList": "Senarai baharu",
    "done": "Selesai",
    "emptyTitle": "Belum ada tugasan",
    "emptySubtitle": "Tambah satu di bawah untuk bermula.",
    "noFilterMatch": "Tiada tugasan sepadan dengan penapis ini.",
    "createIn": "Cipta dalam",
    "inDestination": "dalam {{destination}}",
    "createIn_aria": "Cipta dalam {{destination}}",
    "createInAccount_aria": "Cipta dalam {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Mencipta dalam {{destination}}…",
    "createFailed": "Tidak dapat mencipta “{{name}}” dalam {{destination}}.",
    "createLimit": "{{destination}} telah mencapai had senarai.",
    "keepInRhemn": "Kekalkan dalam Rhemn"
  },
  "filter": {
    "label": "Penapis",
    "all": "Semua"
  },
  "voice": {
    "mic_aria": "Tambah tugasan dengan suara",
    "mic_title": "Sebutkan tugasan anda — disusun ikut keutamaan dan masa",
    "stop_aria": "Berhenti dan susun tugasan",
    "recording": "Merakam",
    "sorting": "Menyusun tugasan anda…",
    "stripTitle": "Tugasan yang didengar",
    "stripCount": "{{checked}} daripada {{total}}",
    "discard": "Buang",
    "addN": "Tambah {{count}}",
    "addZero": "Tambah",
    "adding": "Menambah…",
    "parseFallback": "Tidak dapat disusun — kata-kata anda ada dalam kotak.",
    "nothingHeard": "Tidak jelas — cuba lagi.",
    "micDenied": "Mikrofon disekat — benarkan dalam tetapan.",
    "gateBody": "Sebutkan tugasan anda — disusun ikut keutamaan dan blok solat. Termasuk dengan Pro.",
    "listen_aria": "Mendengar — sebutkan tugasan anda"
  }
}
